// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1426":"0cdceced","2346":"f8835319","8003":"a2d603e0"}[chunkId] + ".chunk.css";
};